// extracted by mini-css-extract-plugin
module.exports = {"main":"ProfileLinks_main__c719u","link":"ProfileLinks_link__23ppe"};